import { useState } from 'react'
import { Avatar } from 'src/@/components/ui/avatar'
import { Button } from 'src/@/components/ui/button'
import { Switch } from 'src/@/components/ui/switch'
import classNames from 'src/utils/classNames'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "src/@/components/ui/dialog"
import { isLastChild } from 'src/utils/functions'

import Iconify from 'src/components/Iconify';

import logoMake from 'src/assets/images/integrations/make.png'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import Scrollbar from 'src/components/Scrollbar'


const data = [
   
]


const DialogItem = ({ selectedIntegration }) => {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button variant="ghost">Saiba mais</Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Edit profile</DialogTitle>
                    <DialogDescription>
                        Make changes to your profile here. Click save when you're done.
                    </DialogDescription>
                </DialogHeader>
                <div className="flex items-center gap-3">
                    <Avatar
                        className="bg-transparent dark:bg-transparent p-2 border-2 border-gray-200 dark:border-gray-600"
                        size={55}
                        src={selectedIntegration.integration.img}
                        shape="round"
                    />
                    <div>
                        <div className="flex items-center gap-1">
                            <h6 className="font-bold">
                                {selectedIntegration.integration.name}
                            </h6>
                            <Iconify icon="mdi:check-circle" className="text-primary text-lg" />
                        </div>
                        <span className="flex gap-2">
                            <span>{selectedIntegration.integration.description}</span>
                        </span>
                    </div>
                </div>
                <div className="mt-6">
                    <span className="font-bold heading-text">Overview</span>
                    <p className="mt-2">
                        Wings medium plunger pot, redeye doppio siphon froth
                        iced. Latte, and, barista cultivar fair trade grinder
                        caramelization spoon. Whipped, grinder to go brewed est
                        single shot half and half. Plunger pot blue mountain et
                        blue mountain grinder carajillo, saucer half and half
                        milk instant strong.
                    </p>
                    <div className="mt-6">
                        <span className="font-bold heading-text">
                            Key Features:
                        </span>
                        <ul className="list-disc mt-4 flex flex-col gap-3">
                            <li className="flex gap-2">
                                <Iconify icon="mdi:check" className="text-emerald-500 text-xl" />
                                <span>
                                    Fair trade, cortado con panna, crema foam
                                    cinnamon aged.
                                </span>
                            </li>
                            <li className="flex gap-2">
                                <Iconify icon="mdi:check" className="text-emerald-500 text-xl" />

                                <span>
                                    Mug saucer acerbic, caffeine organic
                                    kopi-luwak galão siphon.
                                </span>
                            </li>
                            <li className="flex gap-2">
                                <Iconify icon="mdi:check" className="text-emerald-500 text-xl" />

                                <span>
                                    To go half and half cultivar single origin
                                    ut, french press.
                                </span>
                            </li>
                            <li className="flex gap-2">
                                <Iconify icon="mdi:check" className="text-emerald-500 text-xl" />

                                <span>
                                    Mocha latte flavour cortado cup kopi-luwak.
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <DialogFooter>
                    <Button type="submit">Entendi</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

const SettingIntegration = () => {
    const navigate = useNavigate();
    const { config } = useSelector((state) => state.global);
    const list = config?.global?.integracoes;
    const filter = list?.filter((item) => item.enable === true) || [];


    const [selectedIntegration, setSelectedIntegration] = useState({
        integration: {},
        dialogOpen: false,
    })


    const handleToggle = (bool, id) => {
        const newData = structuredClone(data)
        mutate(
            newData.map((app) => {
                if (app.id === id) {
                    app.active = bool
                }
                return app
            }),
            false,
        )
    }

    const handleDialogClose = () => {
        setSelectedIntegration({
            integration: {},
            dialogOpen: false,
        })
    }

    return (
        <div>

            <div className="mt-4">
                <Scrollbar className="h-[600px]">
                    {filter.map((app, index) => (
                        <div
                            key={app.value}
                            className={classNames(
                                'flex items-center justify-between py-6 border-gray-200 dark:border-gray-700',
                                !isLastChild(data, index) && 'border-b',
                            )}
                        >
                            <div className="flex items-center gap-8">
                                <div className="w-[90px] shadow-md rounded p-2">
                                    <img src={app.img} alt={app.name} />
                                </div>
                                <div>
                                    <h6 className="font-bold">{app.name}</h6>
                                    <span>{app.description}</span>
                                </div>
                            </div>
                            <div className="flex items-center gap-2 justify-center">
                                {app.soon && (
                                    <Button
                                        disabled
                                        variant="secondary"
                                    >
                                        Em breve
                                    </Button>
                                )}

                                {!app.soon && (
                                    <Button
                                        onClick={() => navigate('/dashboard/configuracoes/' + app.value)}
                                        variant="secondary"
                                    >
                                        <Iconify icon="uil:setting" className="text-lg mr-1" />
                                        Configurar
                                    </Button>
                                )}


                            </div>
                        </div>
                    ))}
                </Scrollbar>
            </div>


        </div>
    )
}

export default SettingIntegration
